import React, { Component } from 'react';
import BuscaAvancada, { BuscaAvancadaContext } from '../../../components/BuscaAvancada/buscaAvancada.component';
import Input from '../../../components/Input/input.component';
import SelectMulti from '../../../components/SelectMulti/selectmulti.component';

class PesquisaAvancadaHistoricoDaca extends Component {
	state = {
		filtro: {
			destino: '',
			origem: '',
			tipos: [],
			dataInicial: '',
			dataFinal: '',
		},
	}

	componentDidMount() {
		const { handleClear } = this.props;
		handleClear();
	}

	render() {
		const {
			props: {
				handlePesquisaSimplificada,
				handleSearch,
				handleClear,
				tiposTransacao,
			},
			state: {
				filtro,
			},
		} = this;

		return (
			<BuscaAvancada
				initialValues={filtro}
				handleSearch={(values) => {
					const filtroFinal = {};
					Object.assign(filtroFinal, values);
					filtroFinal.tipos = values.tipos.map(item => item.object.id);
					if (filtroFinal.dataInicial === '') {
						filtroFinal.dataInicial = undefined;
					}
					if (filtroFinal.dataFinal === '') {
						filtroFinal.dataFinal = undefined;
					}
					handleSearch(filtroFinal);
				}}
				handleClear={({ resetForm }) => {
					resetForm();
					handleClear();
				}}
				handlePesquisaSimplificada={handlePesquisaSimplificada}
			>
				<BuscaAvancadaContext.Consumer>
					{({
						values,
						handleChange,
						setFieldValue,
					}) => (
						<React.Fragment>
							<div className='row'>
								<div className='col-6 mb-2'>
									<label>Tipo de transação</label>
									<SelectMulti
										isMulti
										isClearable
										name='tipos'
										uniqueKey='id'
										label='nome'
										onChange={(value) => {
											setFieldValue('tipos', value);
										}}
										value={values.tipos || []}
										options={tiposTransacao}
									/>
								</div>

								<div className='col-3 mb-2'>
									<label>Data inicial</label>
									<div className='form-group'>
										<Input
											type='date'
											name='dataInicial'
											onChange={handleChange}
											value={values.dataInicial}
											max={values.dataFinal ? values.dataFinal : undefined}
										/>
									</div>
								</div>
								<div className='col-3 mb-2'>
									<label>Data final</label>
									<div className='form-group'>
										<Input
											type='date'
											name='dataFinal'
											onChange={handleChange}
											value={values.dataFinal}
											min={values.dataInicial ? values.dataInicial : undefined}
										/>
									</div>
								</div>

								<div className='col-6'>
									<label>Origem</label>
									<div className='form-group'>
										<Input
											type='text'
											name='origem'
											onChange={handleChange}
											value={values.origem}
										/>
									</div>
								</div>

								<div className='col-6'>
									<label>Destino</label>
									<div className='form-group'>
										<Input
											type='text'
											name='destino'
											onChange={handleChange}
											value={values.destino}
										/>
									</div>
								</div>
							</div>
						</React.Fragment>
					)}
				</BuscaAvancadaContext.Consumer>
			</BuscaAvancada>
		);
	}
}

export default PesquisaAvancadaHistoricoDaca;
